import { useEffect } from "react"
import { Route, Routes } from "react-router-dom"

import { Provider } from "urql"

import { goldsky } from "./api/graphql-client"
import { useTokenPrices } from "./api/portfolio-api"
import RootLayoutUI from "./components/RootLayout/RootLayoutUI"
import { PoolProvider } from "./context/PoolContext"
import { AgentBlueprintPage } from "./pages/AgentBlueprintPage/AgentBlueprintPage"
import { EntityPage } from "./pages/EntityPage/EntityPage"
import { HomePage } from "./pages/HomePage/HomePage"
import OnboardingPoolPage from "./pages/OnboardingPool/OnboardingPoolPage"
import PoolNotFound from "./pages/PoolNotFound"
import { PoolPage } from "./pages/PoolPage/PoolPage"
import TokenPage from "./pages/Token/Token"
import UpdateTokenPage from "./pages/UpdateToken/UpdateToken"
import { $arPrice } from "./stores/currency-store"
import { $poolsOverviewMap } from "./stores/pools-store"
import { PoolOverview } from "./types"
import { getOverview, getOverviewHB } from "@/api/monitor-api"
import { getNativeArPrice } from "@/api/price-oracle-api"
import { parseAsBoolean, parseAsString, useQueryState } from "nuqs"
import { DEFAULT_GET_OVERVIEW_HB } from "./settings"
import { useQuery } from "@tanstack/react-query"

export const App = () => {
  const { data: overviewData } = useQuery({
    queryKey: ["getOverview"],
    queryFn: () => getOverview(undefined, undefined),
  })

  useEffect(() => {
    getNativeArPrice()
      .then($arPrice.set)
      .catch((err) => {
        console.error(err)
        $arPrice.set(null)
      })

    getOverview(undefined, undefined).then((overview) => {
      const map = overview.reduce(
        (acc, overview) => ({
          ...acc,
          [overview.poolId]: overview,
        }),
        {} as Record<string, PoolOverview>,
      )

      $poolsOverviewMap.set(map)
    })
  }, [overviewData])

  useTokenPrices()

  return (
    <RootLayoutUI>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/entity/:entityId" element={<EntityPage />} />
        <Route
          path="/pool/:poolId"
          element={
            <PoolProvider>
              <PoolPage />
            </PoolProvider>
          }
        />
        <Route path="/agent-blueprint/:blueprintId" element={<AgentBlueprintPage />} />
        <Route
          path="/onboarding-pool/:poolId"
          element={
            <Provider value={goldsky}>
              <OnboardingPoolPage />
            </Provider>
          }
        />
        <Route path="/token/:tokenId/update-metadata" element={<UpdateTokenPage />} />
        <Route path="/token/:tokenId" element={<TokenPage />} />

        <Route path="/pool-not-found" element={<PoolNotFound />} />
      </Routes>
    </RootLayoutUI>
  )
}
